import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';

export class MerchantServiceTimesDto extends BaseDto {
  merchantId: number;
  name: string;
  startTime?: string;
  endTime?: string;
  merchant: MerchantDto;
}
